var _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurityVerificationFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 49.5,
    cy: 50,
    rx: 37.5,
    ry: 38,
    fill: "#FF453A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.3223 12L45.9993 36.6348L21.6777 12.0014L7 26.8659L31.3216 51.5007L7 76.1355L21.6777 91L45.9993 66.3666L70.3223 91L85 76.1355L60.677 51.5007L85 26.8659L70.3223 12Z",
    fill: "#FF453A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1412 64.0176L29.4895 88.2837L15.6982 74.1355L39.3678 49.8497L39.708 49.5007L39.3678 49.1517L15.6982 24.8659L29.4895 10.7178L53.1412 34.9838L53.4993 35.3512L53.8573 34.9838L77.5104 10.7163L91.3018 24.8659L67.6308 49.1517L67.2906 49.5007L67.6308 49.8497L91.3018 74.1355L77.5105 88.2837L53.8573 64.0176L53.4993 63.6503L53.1412 64.0176Z",
    stroke: "#FAE451"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityVerificationFailed);
export default __webpack_public_path__ + "static/media/securityVerificationFailed.6255ff0809dcb9d8c83c57037bbb904b.svg";
export { ForwardRef as ReactComponent };